import { useEffect, useState, startTransition } from 'react';

/**
 * Returns true after the next two animation frames and a transition commit.
 * Use to defer mounting heavy content until after first paint so the view stays responsive.
 * @returns true when the deferred mount should run
 */
export const useDeferMount = (): boolean => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let innerId: number | undefined;
    const outerId = requestAnimationFrame(() => {
      innerId = requestAnimationFrame(() => {
        startTransition(() => setReady(true));
      });
    });
    return () => {
      cancelAnimationFrame(outerId);
      if (innerId !== undefined) cancelAnimationFrame(innerId);
    };
  }, []);
  return ready;
};
